import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
  },
  categories: ({ showInternalCustoms }: { showInternalCustoms: boolean }) => ({
    width: '100%',
    padding: 0,
    display: showInternalCustoms ? 'none' : '',
    overflowY: 'auto',
    '@media screen and (width >= 768px)': {
      display: 'block',
    },
  }),
  categoryItem: {
    border: `1px solid ${neutral['20']}`,
    '&:hover': {
      backgroundColor: neutral['10'],
    },
  },
  categoryItemTextPrimary: {
    marginLeft: '0.5rem',
    fontWeight: 500,
    color: neutral[100],
  },

  customizationsContainer: {
    width: '100%',
    overflowY: 'auto',
  },
  customizationsTitle: {
    padding: '1rem',
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: neutral[100],
    textWrap: 'pretty',
  },
});
